var path = '/templates/zenclerk_s/sites/reports/show/report_show.html';
var html = "<div class=\"container-fluid sub-navigation-command\"><div class=col-md-12><zc-month-chooser min-date=vm.project.created_at></zc-month-chooser></div></div><zcs-monthly-report project=vm.project month=vm.month invoices=vm.invoices></zcs-monthly-report><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/reports/show/report_show.html
// module id = 1427
// module chunks = 0